import { Root, Item } from '@radix-ui/react-toggle-group';

import { css, styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Container = styled(Root)<{ $variant: string }>`
  align-items: flex-start;
  ${({ $variant }) =>
    $variant === 'buttons' ? `background-color: ${Colors.blue[3]};` : `background-color: "transparent"`}
  border-radius: ${BorderRadius.S};
  cursor: pointer;
  display: inline-flex;
  height: 100%;
  padding: ${Spacing['3Xs']};
`;

export const OptionLabel = styled(Item)<{ $variant: string }>`
  align-items: center;
  background-color: transparent;

  border: none;

  cursor: pointer;

  display: flex;
  gap: ${Spacing.Xxs};
  height: inherit;
  justify-content: center;
  padding: 0.75rem ${Spacing.Xs};
  white-space: nowrap;

  transition:
    color 0.25s,
    background-color 0.1s;

  ${({ $variant }) =>
    $variant === 'buttons'
      ? css`
          border-radius: ${BorderRadius.Xs};
          color: ${Colors.blue[20]};
          &[data-state='on'] {
            background-color: ${Colors.blue[100]};
            color: ${Colors.white};
          }
        `
      : css`
          color: ${Colors.gray[50]};
          &[data-state='on'] {
            border-bottom: ${`2px solid ${Colors.blue[100]}`};
            color: ${Colors.blue[100]};
          }
        `}
`;
